(function () {
    'use strict';

    angular
        .module('riskEditModule')
        .controller('RiskEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'topBarService', 'grcRiskService', 'risk'];

    function Controller($scope, $state, $stateParams, topBarService, grcRiskService, risk) {

        topBarService.setTitleAndIcon('Manage Risks', 'fa fa-bolt');

        $scope.ctrlCtxt = {};

        if (_.isUndefined(risk) || _.isEmpty(risk)) {
            $state.go('riskNotExists', { RiskID: $stateParams.RiskID });
            return;
        }

        // Risk
        $scope.risk = risk;
        $scope.goToRisk = function (item) {
            $state.go('riskEdit', { RiskID: item.RiskID });
        }

        // Sub Risks 
        $scope.getSubRisks = function (item) {
            if (_.isUndefined(item.RiskID)) return;
            return grcRiskService.getSubRisks(item.RiskID);
        }

        $scope.goToSubRisks = function (item) {
            $state.go('riskEdit.SubRisks', { RiskID: item.RiskID });
        }

        // Related Controls 
        $scope.getRelatedControls = function (item) {
            if (_.isUndefined(item.RiskID)) return;
            return grcRiskService.getRelatedControls(item.RiskID);
        }

        $scope.goToRelatedControls = function (item) {
            $state.go('riskEdit.RelatedControls', { RiskID: item.RiskID });
        }

        $scope.showRelatedControls = function () {
            if (!$scope.risk.RiskID) return false;
            if ($scope.risk.IsClosed) return false;
            if (!$scope.risk.RiskLevel.IsDepartmentRisk) return false;

            return true;
        }

        // Related Risk Events 
        $scope.getRelatedRiskEvents = function (item) {
            if (_.isUndefined(item.RiskID)) return;
            return grcRiskService.getRelatedRiskEvents(item.RiskID);
        }

        $scope.goToRelatedRiskEvents = function () {
            $state.go('riskEdit.RelatedRiskEvents');
        }

        $scope.showRelatedRiskEvents = function () {
            if (!$scope.risk.RiskID) return false;
            if ($scope.risk.IsClosed) return false;
            if (!$scope.risk.RiskLevel.IsDepartmentRisk) return false;
            if (!$scope.authenticatedUser.User.IsInRiskManagementGroup) return false;

            return true;
        }

        // History on Risk
        $scope.getHistoricOnRisk = function (item) {
            if (_.isUndefined(item.RiskID)) return;
            return grcRiskService.getHistoricOnRisk(item.RiskID);
        }

        $scope.goToHistoryRisk = function (item) {
            $state.go('riskEdit.History', { RiskID: item.RiskID });
        }
    }
})();